<dx-popup
    [minWidth]="isSmallScreen ? popupWidth : undefined"
    [minHeight]="isSmallScreen ? popupHeight : undefined"
    [maxWidth]="!isSmallScreen ? popupWidth : undefined"
    [maxHeight]="!isSmallScreen ? popupHeight : undefined"
    [title]="popupTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="true"
    [showCloseButton]="true"
    [(visible)]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'" class="community-owner-alerts-editor-container">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-form
                        #alertForm
                        *ngIf="formParam"
                        width="100%"
                        height="100%"
                        [formData]="formParam"
                        [scrollingEnabled]="true"
                    >
                        <dxi-item itemType="group" [colCount]="1">
                            <dxi-item
                                dataField="community"
                                [editorOptions]="{ readOnly: true, tabIndex: 0 }"
                            ></dxi-item>
                            <dxi-item
                                dataField="createdBy"
                                [editorOptions]="{ readOnly: true, tabIndex: 1 }"
                            ></dxi-item>
                            <dxi-item
                                dataField="priority"
                                editorType="dxRadioGroup"
                                [editorOptions]="{
                                    items: priorities,
                                    displayExpr: 'text',
                                    valueExpr: 'id',
                                    layout: 'horizontal',
                                    tabIndex: 2
                                }"
                            ></dxi-item>
                        </dxi-item>
                        <dxi-item itemType="group" [colCount]="5">
                            <dxi-item
                                [colSpan]="2"
                                dataField="effectiveDate"
                                [isRequired]="true"
                                editorType="dxDateBox"
                                [editorOptions]="{
                                    max: formParam?.endDate,
                                    tabIndex: 3
                                }"
                            >
                                <dxo-label text="Begin Date"></dxo-label>
                            </dxi-item>
                            <dxi-item
                                [colSpan]="2"
                                dataField="endDate"
                                [isRequired]="!formParam?.noEndDate"
                                editorType="dxDateBox"
                                [editorOptions]="{
                                    disabled: formParam?.noEndDate,
                                    min: formParam?.effectiveDate,
                                    tabIndex: 4
                                }"
                            ></dxi-item>
                            <dxi-item
                                dataField="noEndDate"
                                editorType="dxCheckBox"
                                [editorOptions]="{
                                    text: 'No End Date',
                                    tabIndex: 5,
                                    onValueChanged: onEndDateFlagChange
                                }"
                            >
                                <dxo-label [visible]="false"></dxo-label>
                            </dxi-item>
                        </dxi-item>
                        <dxi-item itemType="group" [colCount]="1">
                            <dxi-item
                                dataField="subject"
                                [isRequired]="true"
                                [editorOptions]="{
                                    maxLength: 2000,
                                    tabIndex: 6
                                }"
                            ></dxi-item>
                            <dxi-item
                                dataField="text"
                                [isRequired]="true"
                                editorType="dxTextArea"
                                [editorOptions]="{
                                    height: 180,
                                    tabIndex: 7
                                }"
                            ></dxi-item>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    hint="Cancel"
                                    [tabIndex]="8"
                                    [icon]="iconCancel"
                                    (onClick)="onCancelClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="OK"
                                    hint="OK"
                                    [tabIndex]="9"
                                    [icon]="iconOk"
                                    (onClick)="onOkClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    [position]="{ of: 'body' }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
